import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useSiteSettings } from "@/context/SiteSettingsContext";

const KEY = "outlawd_dark_mode";
const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const site = useSiteSettings();
  const siteDefault = !!site?.dark_mode_default;

  const [dark, setDark] = useState(() => {
    const raw = localStorage.getItem(KEY);
    if (raw === "1") return true;
    if (raw === "0") return false;
    return null; // fall back to site default
  });

  // When site default changes and user hasn't chosen, follow site default
  const effectiveDark = dark === null ? siteDefault : dark;

  useEffect(() => {
    const root = document.documentElement;
    if (effectiveDark) root.classList.add("dark");
    else root.classList.remove("dark");
  }, [effectiveDark]);

  const toggle = () => {
    setDark((prev) => {
      const cur = prev === null ? siteDefault : prev;
      const next = !cur;
      localStorage.setItem(KEY, next ? "1" : "0");
      return next;
    });
  };

  const value = useMemo(() => ({ dark: effectiveDark, toggle }), [effectiveDark]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
